import Link from 'next/link'
import { InlineSvg } from 'components/patterns/icons/svg-tools/InlineSvg'
import fionaLogo from 'components/layout/assets/fiona-logo.inline.svg'
import { Progress, View } from 'reshaped/bundle'

interface Props {
	leftCTA?: JSX.Element
	rightCTA?: JSX.Element
	progress: number
}

export const ApplicationHeader = ({ leftCTA, rightCTA, progress }: Props) => (
	<View
		position="fixed"
		width="100%"
		align="center"
		attributes={{ style: { zIndex: 9, background: 'linear-gradient(90deg, #3b0d68 0%, #592b86 100%)' } }}
	>
		<View maxWidth="1280px" width="100%" paddingInline={4}>
			<View
				height={18}
				width="100%"
				direction="row"
				align="center"
				attributes={{ style: { justifyContent: 'space-between' } }}
			>
				<View attributes={{ style: { minWidth: '95px' } }}>{leftCTA}</View>
				<Link passHref href={'/'}>
					<InlineSvg width="96px" height="28px" src={fionaLogo} />
				</Link>
				<View attributes={{ style: { minWidth: '95px' } }}>{rightCTA}</View>
			</View>
		</View>
		<View width="100%">
			<Progress value={progress || 0} color="positive" size="small" />
		</View>
	</View>
)
